import React, { useContext, useEffect, useRef, useState } from 'react';
import Modal from "react-bootstrap/Modal";
import { Col, Container, Dropdown, Form, Spinner, Button } from "react-bootstrap";
import { Context } from "../../../index";
import { observer } from "mobx-react-lite";
import {
    updateBook
} from "../../../http/bookAPI";
import AvatarEditor from 'react-avatar-editor';
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Row from "react-bootstrap/Row";
import {getRedirectUrlApi} from "../../../http/userAPI";

const EditBook = observer(({ show, handleClose, bookData, onUpdate }) => {
    const { book } = useContext(Context);
    const { user } = useContext(Context);

    const [originalCover, setOriginalCover] = useState(null);

    const [showEditor, setShowEditor] = useState(false); // Управление отображением редактора
    const [scale, setScale] = useState(1);
    const [editorRef, setEditorRef] = useState(null);
    const [editorSize, setEditorSize] = useState({ width: 272, height: 410 });


    const [titleState, setTitleState] = useState(bookData?.title || '');
    const [subtitleState, setSubTitleState] = useState(bookData?.subtitle || '');
    const [authorState, setAuthorState] = useState(bookData?.author || '');
    const [summaryState, setSummaryState] = useState(bookData?.summary || '');
    const [coverPreview, setCoverPreview] = useState(null);
    const [coverFileState, setCoverFileState] = useState(null);
    const [loading, setLoading] = useState(false);
    const [bookFormat, setBookFormat] = useState("6x9");

    const [paperbackAsinState, setPaperBackAsinState] = useState( '');
    const [kindleAsinState, setKindleAsinState] = useState('');
    const [hardcoverAsinState, setHardCoverAsinState] = useState('');
    const [audioAsinState, setAudioAsinState] = useState('');
    const [audibleAsinState, setAudibleAsinState] = useState('');
    const [audioBookLinkState, setAudioBookLinkState] = useState('');

    const [tempPDFFileE, setTempPDFFileE] = useState(''); // Для временного файла
    const [uploadProgress, setUploadProgress] = useState(0); // Для прогресса загрузки
    const [pdfFileTitle, setPdfFileTitle] = useState("")
    const [pdffile, setPdfFile] = useState(null)

    const parentRef = useRef(null);



    useEffect(() => {
        if (show && bookData) {
            setTitleState(bookData.title || '');
            setSubTitleState(bookData.subtitle || '');
            setAuthorState(bookData.author || '');
            setSummaryState(bookData.summary || '');
            setPaperBackAsinState(bookData.paper_back_asin || '');
            setKindleAsinState(bookData.kindle_asin || '');
            setHardCoverAsinState(bookData.hard_cover_asin || '');
            setAudioAsinState(bookData.audio_asin || '');
           // setTempPDFFile(bookData.book_temp_file || '');
            setPdfFileTitle(bookData.book_download || '');
            setCoverPreview(`${process.env.REACT_APP_API_URL}covers/${bookData.cover_file}`);
            setAudibleAsinState(bookData.audio_audible_asin || '');
            setAudioBookLinkState(bookData.audio_download_link_ned || '');
            setNewBook(bookData)
            if (bookData?.booksLanguageId) {
                const selectedLang = book.languages.find(lang => lang.id === bookData.booksLanguageId);
                if (selectedLang) {
                    book.setSelectedLanguage(selectedLang);
                }
            }
            if (bookData?.booksGenreId) {
                const selectedGen = book.genres.find(gen => gen.id === bookData.booksGenreId);
                if (selectedGen) {
                    book.setSelectedGenre(selectedGen);
                }
            }
                setNewBook({
                    paper_back_flag: bookData?.paper_back_flag || false,
                    kindle_flag: bookData?.kindle_flag || false,
                    kindle_unlimited_flag: bookData?.kindle_unlimited_flag || false,
                    hard_cover_flag: bookData?.hard_cover_flag || false,
                    audio_flag: bookData?.audio_flag || false,
                    audio_exclusive_flag: bookData?.audio_exclusive_flag || false,
                    audio_non_exclusive_flag: bookData?.audio_non_exclusive_flag || false,
                });

        }
    }, [show, bookData?.id]);

    // 📌 Соотношения сторон для разных форматов книг
    const bookSizes = {
        "6x9": { aspectRatio: 6 / 9 },
        "8.5x11": { aspectRatio: 8.5 / 11 },
        "8.5x8.5": { aspectRatio: 8.5 / 8.5 },
        "8x10": { aspectRatio: 8 / 10 },
        "5x8": { aspectRatio: 5 / 8 },
        "7x10": { aspectRatio: 7 / 10 },
    };

    // 🔹 Функция обновления размеров (по `bookFormat` и при `resize`)
    useEffect(() => {
        const updateSize = () => {
            if (parentRef.current) {
                const parentWidth = parentRef.current.clientWidth;
                const selectedSize = bookSizes[bookFormat] || bookSizes["6x9"];
                const newHeight = parentWidth / selectedSize.aspectRatio;
                setEditorSize({ width: parentWidth, height: newHeight });
            }
        };

        updateSize();
        window.addEventListener("resize", updateSize);
        return () => window.removeEventListener("resize", updateSize);
    }, [bookFormat]); // Обновление при изменении формата книги

    const [newBook, setNewBook] = useState(
        {
            paper_back_flag: false,
            kindle_flag: false,
            kindle_unlimited_flag: false,
            hard_cover_flag: false,
            audio_flag: false,
            audio_exclusive_flag: false,
            audio_non_exclusive_flag: false,
        }
    );

   const internalHandleClose = () => {
        if (bookData) {
            setTitleState('');
            setSubTitleState('');
            setAuthorState('');
            setSummaryState('');
            setPaperBackAsinState('');
            setKindleAsinState('');
            setHardCoverAsinState('');
            setAudioAsinState('');
            setAudibleAsinState('');
            setAudioBookLinkState('');
            setTempPDFFileE('');
            setPdfFileTitle('');
            setCoverPreview('');
            setOriginalCover(null);
            book.setSelectedLanguage({});
            book.setSelectedGenre({});
          //  book.setSelectedCurrentUserBook({});
            setNewBook({
                paper_back_flag: false,
                kindle_flag: false,
                kindle_unlimited_flag: false,
                hard_cover_flag: false,
                audio_flag: false,
                audio_exclusive_flag: false,
                audio_non_exclusive_flag: false,
            });

        }

        handleClose(); // Закрываем модалку
    };



    const handleCheckboxChange = (e) => {
        const { name, checked } = e.target;

        setNewBook((prevBook) => {
            let updatedBook = { ...prevBook, [name]: checked };

            // Если выбрали "Exclusive", отключаем "Non-Exclusive"
            if (name === "audio_exclusive_flag" && checked) {
                updatedBook.audio_non_exclusive_flag = false;
            }

            // Если выбрали "Non-Exclusive", отключаем "Exclusive"
            if (name === "audio_non_exclusive_flag" && checked) {
                updatedBook.audio_exclusive_flag = false;
            }

            return updatedBook;
        });
    };



// ✅ Функция для клика по скрытому input
    const triggerFileInputBook = () => {
        document.getElementById("fileInputBook").click();
    };


// ✅ Функция загрузки файла
    const selectBookFile = (e) => {
        const file = e.target.files[0];
        if (!file) {
            toast.error("Error: No file selected.", { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
            return;
        }

        // 🔹 Проверка формата и размера файла
        if (file.type !== "application/pdf") {
            toast.error(`Error: File "${file.name}" is not a PDF.`, { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
            return;
        }

        const maxFileSize = 500 * 1024 * 1024; // 500MB in bytes
        if (file.size > maxFileSize) {
            toast.error(`Error: File "${file.name}" exceeds 500MB limit.`, { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
            return;
        }

        // 🔹 Обновляем состояние файла
        setPdfFile(file);
        setPdfFileTitle(file.name); // Save the original file name


        // 🔹 Создаем `FormData` и загружаем файл
        const formData = new FormData();
        formData.append("book_download_temp", file);

        try {
            const xhr = new XMLHttpRequest();
            xhr.open("POST", process.env.REACT_APP_API_URL + "api/book/temp", true);

            // 🔹 Обработчик прогресса
            xhr.upload.onprogress = (event) => {
                if (event.lengthComputable) {
                    const percentComplete = Math.round((event.loaded / event.total) * 100);
                    setUploadProgress(percentComplete >= 100 ? 99 : percentComplete);
                }
            };

            // 🔹 Обработчик завершения загрузки
            xhr.onload = () => {
                if (xhr.status === 200) {
                    toast.success("File uploaded successfully!", { position: "bottom-center", autoClose: 3000, hideProgressBar: false });

                    const response = JSON.parse(xhr.responseText);
                    const tempFileName = response.tempPDFFile;

                    // 🔹 Save temporary file name
                    setTempPDFFileE(tempFileName);


                    setUploadProgress(100);
                } else {
                    let errorMessage = `Upload failed: ${xhr.status}`;
                    try {
                        errorMessage = JSON.parse(xhr.responseText)?.message || errorMessage;
                    } catch (_) {}
                    toast.error(errorMessage, { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
                    setUploadProgress(-1);
                }
            };

            // 🔹 Обработчик ошибок
            xhr.onerror = () => {
                toast.error("Error uploading file.", { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
                setUploadProgress(-1);
            };

            // 🔹 Отправляем файл на сервер
            xhr.send(formData);
        } catch (error) {
            toast.error(`Error sending file: ${error.message}`, { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
        }
    };


    const handleUpdateBook = async () => {
        setLoading(true);

        try {
            const formData = new FormData();
            formData.append('userId', user.user.id || bookData.userId);
            formData.append('booksGenreId', book.selectedGenre.id || bookData.booksGenreId);
            formData.append('booksPriceId', 1);
            formData.append('booksLanguageId', book.selectedLanguage.id || bookData.booksLanguageId);
            formData.append('title', titleState || '');
            formData.append('subtitle', subtitleState || '');
            formData.append('author', authorState || '');
            formData.append('summary', summaryState || '');
            formData.append('paper_back_flag', newBook.paper_back_flag || false);
            formData.append('kindle_flag', newBook.kindle_flag || false);
            formData.append('kindle_unlimited_flag', newBook.kindle_unlimited_flag || false);
            formData.append('hard_cover_flag', newBook.hard_cover_flag || false);
            formData.append('audio_flag', newBook.audio_flag || false);
            formData.append('audio_exclusive_flag', newBook.audio_exclusive_flag || false);
            formData.append('audio_non_exclusive_flag', newBook.audio_non_exclusive_flag || false);
            formData.append('paper_back_asin', paperbackAsinState || '');
            formData.append('kindle_asin', kindleAsinState || '');
            formData.append('hard_cover_asin', hardcoverAsinState || '');
            formData.append('audio_asin', audioAsinState || '');
            formData.append('audio_audible_asin', audibleAsinState || '');
            formData.append('audio_download_link_ned', audioBookLinkState || '');
            formData.append('status', 'NEW');

            if (coverFileState) {
                formData.append('cover_file', coverFileState);
            }

            // 🔹 Добавляем файл книги (если есть)
            if (tempPDFFileE) {

                formData.append("book_download", tempPDFFileE);
            } else {

            }

            await updateBook(bookData.id, formData);
            book.setSelectedCurrentUserBook({formData});
            toast.success("Book updated successfully!", { position: "bottom-center", autoClose: 3000, hideProgressBar: false });

            if (onUpdate) {
                onUpdate(); // Вызов обновления в родителе
            }

            handleClose();
        } catch (e) {
            toast.error("Error updating book!", { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
        } finally {
            setLoading(false);
        }
    };

    const triggerFileInput = () => {
        document.getElementById("fileInput").click();
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file && file.type.startsWith("image/")) {
            setOriginalCover(file);
            const reader = new FileReader();
            reader.onload = (event) => {
                const imageBase64 = event.target.result;

                setCoverPreview(imageBase64);
                setShowEditor(true);


            };
            reader.readAsDataURL(file);
        }
    };



    const handleSave = () => {
        if (editorRef) {
            try {
                const canvas = editorRef.getImageScaledToCanvas();
                canvas.toBlob(
                    (blob) => {
                        if (blob) {
                            const reader = new FileReader();
                            reader.onload = (event) => {
                                const editedImageBase64 = event.target.result;

                                setCoverPreview(editedImageBase64);
                                setCoverFileState(blob);
                                setShowEditor(false);




                            };
                            reader.readAsDataURL(blob);
                        } else {

                        }
                    },
                    'image/jpeg',
                    0.9
                );
            } catch (error) {

            }
        } else {

        }
    };


    const handleEditOriginal = () => {
        let coverToEdit = originalCover;

        // ✅ Если `originalCover` отсутствует, загружаем из `localStorage`
        if (!coverToEdit) {
            const savedCover = localStorage.getItem("bookForm");
            if (savedCover) {
                const bookData = JSON.parse(savedCover);
                if (bookData.cover_file) {
                    coverToEdit = bookData.cover_file;

                }
            }
        }

        if (!coverToEdit) {

            return;
        }

        // ✅ Загружаем обложку в редактор
        setCoverPreview(coverToEdit);
        setShowEditor(true);
    };




    return (
        <Modal
            show={show}
            onHide={internalHandleClose}
            size="xl"
            backdrop="static"
            keyboard={false}
            id="staticBackdrop"
            aria-labelledby="staticBackdropLabel"
            aria-hidden="true"

        >

            <div className="modal-content">
                <div className="modal-header">
                    <h1 className="modal-title fs-5">Edit Book with title: {titleState}</h1>
                    <button type="button" className="btn-close" onClick={internalHandleClose}></button>
                </div>
                <Col className="m-lg-2 d-flex small">
                    <div className="modal-body">
                        <Form className="mt-0 mb-3">
                            <Row className="mb-2 p-2 shadow bg-white rounded border">
                                <h6 className="mx-auto p-2"> Edit Book Title: </h6>
                                <Form.Control
                                    className="p-2 border border-secondary rounded"
                                    value={titleState}
                                    onChange={e => setTitleState(e.target.value)}
                                    placeholder="Book Title"
                                />
                            </Row>

                            <Row className="mb-2 p-2 shadow bg-white rounded border">
                                <h6 className="mx-auto p-2"> Edit Book Subtitle: </h6>
                                <Form.Control
                                    className="p-2 border border-secondary rounded"
                                    value={subtitleState}
                                    onChange={e => setSubTitleState(e.target.value)}
                                    placeholder="Book Subtitle"
                                />
                            </Row>

                            <Row className="mb-2 p-2 shadow bg-white rounded border">
                                <h6 className="mx-auto p-2"> Edit Author Name: </h6>
                                <Form.Control
                                    className="p-2 border border-secondary rounded"
                                    value={authorState}
                                    onChange={e => setAuthorState(e.target.value)}
                                    placeholder="Author Name"
                                />
                            </Row>



                            <Row className="mb-2 p-2 shadow bg-white rounded border">


                                <Col md={12} className="start-0">

                                    <h6 className="mx-auto mt-2 ">Edit Book Language, Genre, Type and Options: </h6>
                                </Col>

                                <Row className="h-100" >
                                    <Col xs={4} className="d-flex flex-column justify-content-start ">
                                        <div className="d-flex flex-column mb-0 align-items-start">
                                            <strong className="mb-1 mt-0 text-muted">Edit Language of Book:</strong>
                                            <Dropdown className="mb-0">
                                                <Dropdown.Toggle
                                                    variant="light"
                                                    style={{
                                                        width: '250px',
                                                        background: 'none',
                                                        border: '1px solid #ced4da',
                                                        color: '#495057',
                                                        textAlign: 'left'
                                                    }}
                                                >
                                                   {
                                                        book.selectedLanguage?.language ||
                                                        (book.languages.length > 0
                                                            ? book.languages.find(lang => lang.id === bookData?.booksLanguageId)?.language
                                                            : "Loading...")
                                                    }

                                                </Dropdown.Toggle>
                                                <Dropdown.Menu style={{ maxHeight: "300px", overflowY: "auto" }}>
                                                    {book.languages.map(lang => (
                                                        <Dropdown.Item onClick={() => book.setSelectedLanguage(lang)} key={lang.id}>
                                                            {lang.language}
                                                        </Dropdown.Item>
                                                    ))}
                                                </Dropdown.Menu>
                                            </Dropdown>
                                        </div>

                                        <div className="d-flex flex-column mb-0 align-items-start">
                                            <strong className="mb-1 mt-2 text-muted">Edit Genre of Book:</strong>
                                            <Dropdown className="mb-5">
                                                <Dropdown.Toggle
                                                    variant="light"
                                                    style={{
                                                        width: '250px',
                                                        background: 'none',
                                                        border: '1px solid #ced4da',
                                                        color: '#495057',
                                                        textAlign: 'left'
                                                    }}
                                                >
                                                    {book?.selectedGenre?.genre || "Select Genre"}
                                                </Dropdown.Toggle>
                                                <Dropdown.Menu style={{ maxHeight: "300px", overflowY: "auto" }}>
                                                    {book.genres.map(gen => (
                                                        <Dropdown.Item onClick={() => book?.setSelectedGenre(gen)} key={gen.id}>
                                                            {gen.genre}
                                                        </Dropdown.Item>
                                                    ))}
                                                </Dropdown.Menu>
                                            </Dropdown>
                                        </div>
                                    </Col>

                                    <Col mb={4} className="d-flex flex-column justify-content-start align-items-stretch">
                                        <strong className="text-muted">Edit Available Types for this Book:</strong>
                                        <Container className="shadow-lg bg-white rounded mt-1 mb-3 ">
                                            <Form.Check
                                                className="mb-2 mt-2"
                                                type="checkbox"
                                                label="This Book is Available in Kindle Version"
                                                name="kindle_flag"
                                                checked={newBook.kindle_flag}
                                                onChange={handleCheckboxChange}
                                            />

                                            <Form.Check
                                                type="checkbox"
                                                className="mb-2 mt-2"
                                                label="This Book is Available in Paperback"
                                                name="paper_back_flag"
                                                checked={newBook.paper_back_flag}
                                                onChange={handleCheckboxChange}
                                            />
                                            <Form.Check
                                                className="mb-2 mt-2"
                                                type="checkbox"
                                                label="This Book is Available in Hardcover"
                                                name="hard_cover_flag"
                                                checked={newBook.hard_cover_flag}
                                                onChange={handleCheckboxChange}
                                            />

                                            <Form.Check
                                                type="checkbox"
                                                className="mb-2 mt-2"
                                                label="This Book is Available in Audio Format"
                                                name="audio_flag"
                                                checked={newBook.audio_flag}
                                                onChange={handleCheckboxChange}
                                            />
                                        </Container>
                                    </Col>

                                    {/* ✅ Колонка с кнопкой прижатой вниз и вправо */}
                                    <Col xs={3} className="d-flex flex-column justify-content-between align-items-stretch" >
                                        {newBook.kindle_flag ? (
                                            <>
                                        <div>

                                                    <strong className="m-2 text-muted">Kindle Unlimited Option?</strong>
                                                    <Container className="shadow-lg bg-white rounded mt-2 p-2">
                                                        <Form.Check
                                                            type="checkbox"
                                                            className="mb-2 mt-2"
                                                            label="Yes, it's Kindle Unlimited!"
                                                            name="kindle_unlimited_flag"
                                                            checked={newBook.kindle_unlimited_flag}
                                                            onChange={handleCheckboxChange}
                                                        />
                                                    </Container>

                                        </div>
                                                </>
                                                ) : null}
                                        {newBook.audio_flag ? (
                                        <div className="mt-2">

                                                <>
                                                    <strong className="m-2 text-muted">Type of Audio Distribution?</strong>
                                                    <Container className="shadow-lg bg-white rounded mb-2 mt-2 p-2">
                                                        <Form.Check
                                                            type="checkbox"
                                                            className="mb-2 mt-2"
                                                            label="Exclusive Distribution"
                                                            name="audio_exclusive_flag"
                                                            checked={newBook.audio_exclusive_flag}
                                                            onChange={handleCheckboxChange}
                                                        />
                                                        <Form.Check
                                                            type="checkbox"
                                                            className="mb-2 mt-2"
                                                            label="Non-Exclusive Distribution"
                                                            name="audio_non_exclusive_flag"
                                                            checked={newBook.audio_non_exclusive_flag}
                                                            onChange={handleCheckboxChange}
                                                        />
                                                    </Container>
                                                </>

                                        </div>
                                        ) : null}

                                    </Col>
                                </Row>


                            </Row>

                            <Row w={100}>

                                <Col md={4} className="mt-0 ">
          <Row w={100} className="mb-2 m-lg-2 mt-2 shadow bg-white rounded">
              <h5 className="mx-auto p-3">ReUpload Cover Image: </h5>
              {coverPreview && (
                  <div  className="text-center mb-3 mt-0 ">
                      {showEditor ? (
                          <>
                              <div ref={parentRef} style={{ width: "90%", maxWidth: "500px", margin: "auto" }} className="mt-1">


                                  <AvatarEditor
                                                                           ref={(ref) => setEditorRef(ref)}
                                                                        image={coverPreview}
                                                                        width={editorSize.width}
                                                                        height={editorSize.height}
                                                                        border={0}
                                                                        scale={scale}
                                                                        borderRadius={0}
                                                                        className="text-center mb-0 mt-0 me-5 m-auto rounded"
                                                                    />
                                                                    <input
                                                                        type="range"
                                                                        min="1"
                                                                        max="2"
                                                                        step="0.005"
                                                                        value={scale}
                                                                        onChange={(e) => setScale(parseFloat(e.target.value))}
                                                                        className="form-range mt-2"
                                                                        style={{width: '100px'}}  // Устанавливаем ширину в 300px
                                                                    />
                                                                    <Row className="d-flex align-items-center justify-content-between mt-2">
                                                                        {/* Выбор формата книги */}
                                                                        <select
                                                                            value={bookFormat}
                                                                            onChange={(e) => setBookFormat(e.target.value)}
                                                                            className="form-select w-auto"
                                                                            style={{minWidth: "120px"}}  // Чтоб select не сжимался слишком сильно
                                                                        >
                                                                            <option value="6x9">Format: 6x9</option>
                                                                            <option value="8.5x11">Format: 8.5x11</option>
                                                                            <option value="8.5x8.5">Format: 8.5x8.5</option>
                                                                            <option value="8x10">Format: 8x10</option>

                                                                            <option value="5x8">Format: 5x8</option>
                                                                            <option value="7x10">Format: 7x10</option>
                                                                        </select>

                                                                        {/* Кнопка */}
                                                                        <button
                                                                            type="button"
                                                                            className="btn btn-success w-auto"
                                                                            onClick={handleSave}
                                                                        >
                                                                            Save Cover
                                                                        </button>


                                                                    </Row>

                                                                </div>
                                                                <Row>

                                                                </Row>


                                                            </>
                                                        ) : (


                                                            <img src={coverPreview}
                                                                  alt="Cover Preview"
                                                                  style={{objectFit: 'cover', borderRadius: '8px'}}
                                                                  width={300}
                                                                  className="img-fluid"/>
                                                        )}

                                                    </div>
                                                )}
                                            </Row>

                                            <Row w={100} className="mb-3 m-lg-2 m-auto mt-3 shadow bg-white rounded">

                                                <div className="d-flex justify-content-center mb-3 mt-3">
                                                    <button
                                                        type="button"

                                                        className="btn btn-primary btn-success flex-md-row me-2 "
                                                        onClick={triggerFileInput}
                                                        disabled={loading}
                                                    >
                                                        Upload New Cover
                                                    </button>

                                                    <input
                                                        type="file"
                                                        id="fileInput"
                                                        style={{display: "none"}}
                                                        onChange={handleFileChange}
                                                    />
                                                    {originalCover ? (
                                                        <>
                                                            <button
                                                                type="button"
                                                                className="btn btn-secondary fflex-md-row me-2 "
                                                                onClick={handleEditOriginal}
                                                            >
                                                                Edit
                                                            </button>

                                                        </>

                                                    ):( "" )}

                                                </div>
                                            </Row>


                                </Col>

                                <Col md={8} className="mt-2 ">
                                    <Row className="mb-3 p-2 shadow bg-white rounded border">
                                        <h6 className="mx-auto p-2">Edit the ASIN's for the type you selected:</h6>

                                        {/* Проверяем, есть ли что-то в первой колонке */}
                                        {(newBook.paper_back_flag || newBook.kindle_flag) && (
                                            <Col md={6} style={{ maxWidth: "100%" }}>

                                                {newBook.kindle_flag && (
                                                    <Form className="mt-0 mb-3">
                                                        <div className="small lh-3">Kindle ASIN:</div>
                                                        <div className="d-flex align-items-center">
                                                            <Form.Control
                                                                className="p-2 border border-secondary rounded"
                                                                value={kindleAsinState}
                                                                onChange={e => setKindleAsinState(e.target.value)}
                                                                placeholder="Enter Kindle ASIN..."
                                                                disabled={loading}
                                                            />
                                                            <Button
                                                                variant="info"
                                                                className="ms-2 btn-sm"
                                                                disabled={!kindleAsinState}
                                                                onClick={async () => {
                                                                    try {
                                                                        const targetUrl = `${user?.user?.amz_country}/dp/${kindleAsinState}`;

                                                                        const response = await getRedirectUrlApi(targetUrl);

                                                                        if (response && response.redirectUrl) {
                                                                            window.open(response.redirectUrl, '_blank', 'noopener noreferrer');
                                                                        } else {
                                                                            console.error('Failed to get redirect URL');
                                                                        }
                                                                    } catch (err) {
                                                                        console.error('Redirect error:', err);
                                                                    }
                                                                }}
                                                            >
                                                                Check
                                                            </Button>
                                                        </div>
                                                    </Form>
                                                )}

                                                {newBook.paper_back_flag && (
                                                    <Form className="mt-0 mb-3">
                                                        <div className="small lh-3">Paperback ASIN:</div>
                                                        <div className="d-flex align-items-center">
                                                            <Form.Control
                                                                className="p-2 border border-secondary rounded"
                                                                value={paperbackAsinState}
                                                                onChange={e => setPaperBackAsinState(e.target.value)}
                                                                placeholder="Enter Paperback ASIN..."
                                                                disabled={loading}
                                                            />
                                                            <Button
                                                                variant="info"
                                                                className="ms-2 btn-sm"
                                                                disabled={!paperbackAsinState}
                                                                onClick={async () => {
                                                                    try {
                                                                        const targetUrl = `${user?.user?.amz_country}/dp/${paperbackAsinState}`;

                                                                        const response = await getRedirectUrlApi(targetUrl);

                                                                        if (response && response.redirectUrl) {
                                                                            window.open(response.redirectUrl, '_blank', 'noopener noreferrer');
                                                                        } else {
                                                                            console.error('Failed to get redirect URL');
                                                                        }
                                                                    } catch (err) {
                                                                        console.error('Redirect error:', err);
                                                                    }
                                                                }}

                                                            >
                                                                Check
                                                            </Button>
                                                        </div>
                                                    </Form>
                                                )}

                                                {(newBook.audio_non_exclusive_flag || newBook.audio_exclusive_flag || newBook.audio_flag) && (
<>
                                                        {(newBook.audio_non_exclusive_flag || newBook.audio_exclusive_flag) && (
                                                            <Form className="mt-0 mb-3">
                                                                <div className="small lh-3">Audible ASIN:</div>
                                                                <div className="d-flex align-items-center">
                                                                    <Form.Control
                                                                        className="p-2 border border-secondary rounded"
                                                                        value={audibleAsinState}
                                                                        onChange={e => setAudibleAsinState(e.target.value)}
                                                                        placeholder="Enter Audible ASIN..."
                                                                        disabled={loading}
                                                                    />
                                                                    <Button
                                                                        variant="info"
                                                                        className="ms-2 btn-sm"
                                                                        disabled={!audibleAsinState}
                                                                        onClick={async () => {
                                                                            try {
                                                                                const targetUrl = `${user?.user?.audible_country}/pd/${audibleAsinState}`;

                                                                                const response = await getRedirectUrlApi(targetUrl);

                                                                                if (response && response.redirectUrl) {
                                                                                    window.open(response.redirectUrl, '_blank', 'noopener noreferrer');
                                                                                } else {
                                                                                    console.error('Failed to get redirect URL');
                                                                                }
                                                                            } catch (err) {
                                                                                console.error('Redirect error:', err);
                                                                            }
                                                                        }}

                                                                    >
                                                                        Check
                                                                    </Button>
                                                                </div>
                                                            </Form>
                                                        )}
</>
                                                )}


                                            </Col>
                                        )}

                                        {/* Если первая колонка есть → вторая md=6, иначе md="auto" */}
                                        <Col md={newBook.paper_back_flag || newBook.kindle_flag ? 6 : 8} style={{ maxWidth: "50%" }}>
                                            {newBook.hard_cover_flag && (
                                                <Form className="mt-0 mb-3">
                                                    <div className="small lh-3">Hardcover ASIN:</div>
                                                    <div className="d-flex align-items-center">
                                                        <Form.Control
                                                            className="p-2 border border-secondary rounded"
                                                            value={hardcoverAsinState}
                                                            onChange={e => setHardCoverAsinState(e.target.value)}
                                                            placeholder="Enter Hardcover ASIN..."
                                                            disabled={loading}
                                                        />
                                                        <Button
                                                            variant="info"
                                                            className="ms-2 btn-sm"
                                                            disabled={!hardcoverAsinState}
                                                            onClick={async () => {
                                                                try {
                                                                    const targetUrl = `${user?.user?.amz_country}/dp/${hardcoverAsinState}`;

                                                                    const response = await getRedirectUrlApi(targetUrl);

                                                                    if (response && response.redirectUrl) {
                                                                        window.open(response.redirectUrl, '_blank', 'noopener noreferrer');
                                                                    } else {
                                                                        console.error('Failed to get redirect URL');
                                                                    }
                                                                } catch (err) {
                                                                    console.error('Redirect error:', err);
                                                                }
                                                            }}

                                                        >
                                                            Check
                                                        </Button>
                                                    </div>
                                                </Form>
                                            )}

                                            {newBook.audio_flag && (
                                                <Form className="mt-0 mb-3">
                                                    <div className="small lh-3">Amazon Audio ASIN:</div>
                                                    <div className="d-flex align-items-center">
                                                        <Form.Control
                                                            className="p-2 border border-secondary rounded"
                                                            value={audioAsinState}
                                                            onChange={e => setAudioAsinState(e.target.value)}
                                                            placeholder="Enter Amazon Audio ASIN..."
                                                            disabled={loading}
                                                        />
                                                        <Button
                                                            variant="info"
                                                            className="ms-2 btn-sm"
                                                            disabled={!audioAsinState}
                                                            onClick={async () => {
                                                                try {
                                                                    const targetUrl = `${user?.user?.amz_country}/dp/${audioAsinState}`;

                                                                    const response = await getRedirectUrlApi(targetUrl);

                                                                    if (response && response.redirectUrl) {
                                                                        window.open(response.redirectUrl, '_blank', 'noopener noreferrer');
                                                                    } else {
                                                                        console.error('Failed to get redirect URL');
                                                                    }
                                                                } catch (err) {
                                                                    console.error('Redirect error:', err);
                                                                }
                                                            }}
                                                        >
                                                            Check
                                                        </Button>
                                                    </div>
                                                </Form>
                                            )}
                                        </Col>




                                        <Row>
                                            {newBook.audio_non_exclusive_flag && (
                                                <Form className="mt-0 mb-3">
                                                    <div className="small lh-3">Enter Link to Your Non-Exclusive
                                                        Audio Book:
                                                    </div>
                                                    <div className="d-flex align-items-center">
                                                        <Form.Control
                                                            className="p-2 border border-secondary rounded"
                                                            value={audioBookLinkState}
                                                            onChange={e => setAudioBookLinkState(e.target.value)}
                                                            placeholder="Enter Link to Your Non-Exclusive Audio Book... https://drive.google.com/drive/"
                                                            disabled={loading}
                                                        />
                                                        <Button
                                                            variant="info"
                                                            className="ms-2 btn-sm"
                                                            disabled={!audioBookLinkState}
                                                            onClick={async () => {
                                                                try {
                                                                    const targetUrl = `${audioBookLinkState}`;

                                                                    const response = await getRedirectUrlApi(targetUrl);

                                                                    if (response && response.redirectUrl) {
                                                                        window.open(response.redirectUrl, '_blank', 'noopener noreferrer');
                                                                    } else {
                                                                        console.error('Failed to get redirect URL');
                                                                    }
                                                                } catch (err) {
                                                                    console.error('Redirect error:', err);
                                                                }
                                                            }}

                                                        >
                                                            Check
                                                        </Button>
                                                    </div>
                                                </Form>
                                            )}
                                        </Row>
                                    </Row>

                                    <Row className="mb-3 p-2 shadow bg-white rounded border">
                                        <h6 className="mx-auto p-2"> Edit Book Summary: </h6>
                                        <Form.Control
                                            className="p-2 border border-secondary rounded"
                                            as="textarea"
                                            rows={3}
                                            value={summaryState}
                                            onChange={e => setSummaryState(e.target.value)}
                                            placeholder="Book Summary"
                                        />
                                    </Row>


                                      <Row className="mb-3 p-3 shadow bg-white rounded border">
                                                <h6 className="mx-auto p-2">
                                                     ReUpload Book File (PDF up to 500 Mb):
                                                </h6>

                                                {/* 🔹 Контейнер для кнопки и индикатора загрузки в одной строке */}
                                                <div className="d-flex align-items-center justify-content-between w-100">
                                                    {/* 🔴 Кнопка загрузки слева */}
                                                    <Button variant="danger" onClick={triggerFileInputBook} className="me-3">
                                                        Upload Book File
                                                    </Button>

                                                    {newBook.book_download || pdfFileTitle ? (
                                                        <>
                                                            {/* 🔹 Индикатор загрузки справа */}
                                                            {uploadProgress > 0 && (
                                                                <div
                                                                    className="progress flex-grow-1"
                                                                    role="progressbar"
                                                                    aria-valuenow={uploadProgress}
                                                                    aria-valuemin="0"
                                                                    aria-valuemax="100"
                                                                    style={{ height: "38px" }} // Увеличенная высота
                                                                >
                                                                    <div
                                                                        className={`progress-bar ${uploadProgress === 100 ? "bg-success" : "bg-info"}`}
                                                                        style={{ width: `${uploadProgress}%` }}
                                                                    >
                                                                        {uploadProgress === 100
                                                                            ? (
                                                                                <span className="fs-6 fst-italic">
                                                                     Uploading {pdfFileTitle.length > 40
                                                                                    ? pdfFileTitle.slice(0, 40) + '...'
                                                                                    : pdfFileTitle
                                                                                } is Complete!
    </span>
                                                                            )
                                                                            : uploadProgress === 99
                                                                                ? <span className="fw-semibold fst-normal">Processing manuscript: watermarking and compressing...</span>
                                                                                : `${uploadProgress}%`
                                                                    }
                                                                    </div>
                                                                </div>
                                                            )}

                                                        </>

                                                    ):("")}

                                                    {(pdfFileTitle && !uploadProgress) && (
                                                        <>
                                                            <Col className="text-center shadow rounded py-2">
                                                                <span className="text-muted fst-italic d-block">Saved: {pdfFileTitle}</span>
                                                            </Col>
                                                        </>
                                                    )}

                                                </div>

                                                {/* 🔹 Скрытый input для загрузки */}
                                                <Form.Group className="mb-3">
                                                    <Form.Control
                                                        type="file"
                                                        accept="application/pdf"
                                                        id="fileInputBook"
                                                        onChange={selectBookFile}
                                                        style={{ display: "none" }}
                                                    />
                                                </Form.Group>

                                                {/* 🔹 Отображение загруженного файла */}
                                                {pdfFileTitle && (
                                                    <div className="mt-1 text-muted">


                                                    </div>
                                                )}

                                          {/* 🔹 Подсказка пользователю */}
                                          <div className="mt-auto d-flex justify-content-end">

                                              {(uploadProgress > 0 && uploadProgress < 100) ? (
                                                  <p className="mb-1 text-muted">Processing manuscript: watermarking and compressing. Please wait...</p>
                                              ) : (uploadProgress !== 100 && !pdfFileTitle) ? (
                                                  <p className="mb-1 text-muted">After Uploading Book File, You Can Send Book to Moderation!</p>
                                              ) : (
                                                  <p className="mb-1 text-muted">Click "Send Book to Moderation"!</p>
                                              )}
                                          </div>
                                            </Row>


                              </Col>

                        </Row>


                        </Form>

                    </div>
                </Col>

                <div className="modal-footer">
                    <Button variant="secondary" onClick={internalHandleClose} disabled={loading}>Close</Button>
                    <Button variant="success" onClick={handleUpdateBook} disabled={loading || (uploadProgress > 0 && uploadProgress < 100)}>
                        {(loading || (uploadProgress > 0 && uploadProgress < 100))
                            ? <><Spinner animation="border" size="sm" /> {uploadProgress === 99 ? "Processing Manuscript" : "Uploading File"}</>
                            : 'Update Book'}
                    </Button>
                </div>
            </div>

        </Modal>

    );
});

export default EditBook;
